import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-ct-three-four-three-one',
  templateUrl: './ct-three-four-three-one.component.html',
  styleUrls: ['./ct-three-four-three-one.component.scss']
})
export class CtThreeFourThreeOneComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  // showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5 ){
      this.showSideMenu=true;
      this.fullWidth=false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
